// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bU_k","importantInfo":"styles_importantInfo__33RRi"};